<template>
    <div class="diagram-record">
        <div class="diagram-record-top-part">
            <!-- 1. 顶部搜索框 -->
            <diagram-top-bar></diagram-top-bar>
            <!-- 2. 记录排序菜单栏 -->
            <div v-if="diagramSearchList && diagramSearchList.length == 0 && !firstDiagramFiltered && !secondDiagramFiltered" class="layout-record-order-bar diagram-record-order dsp-flex">
                <div class="layout-rob-item" :class="{'rob-item-cur2': curOrderIndex == 0}" @click.passive="clickAll">{{curOrderIndex == 0 ? recordAllList[diagramAllRecordOrder] : '全部记录'}}<i class="iconfont rob-icon icon-down"></i></div> <!---v-bind:class="{'icon-up': showAllRecord, 'icon-down': !showAllRecord}-->
                <div class="layout-rob-item rob-item-name" :class="{'rob-item-cur2': curOrderIndex == 1}" @click.passive="clickRecent">最近浏览顺序</div>
                <div class="layout-rob-item rob-item-name" :class="{'rob-item-cur2': curOrderIndex == 2}" @click.passive="clickDiagramTime">起卦时间<i class="iconfont rob-icon" :class="{'icon-up-down': curOrderIndex != 2, 'icon-down': curOrderIndex == 2 && diagramTimeOrder == 0, 'icon-up': curOrderIndex == 2 && diagramTimeOrder == 1}"></i></div>
                <div class="layout-rob-item rob-item-time" :class="{'rob-item-cur2': curOrderIndex == 3}" @click.passive='clickCreateTime'>创建时间<i class="iconfont rob-icon" :class="{'icon-up-down': curOrderIndex != 3, 'icon-down': curOrderIndex == 3 && createTimeOrder == 0, 'icon-up': curOrderIndex == 3 && createTimeOrder == 1}"></i></div>
            </div>
            <div v-else-if="diagramSearchList && diagramSearchList.length > 0" class="diagram-record-search-title">搜索到以下结果：</div>
            <div class="diagram-record-sub-title">
                <div class="title1">标题</div>
                <div class="title2" @click="clickGuaFilter('first')">
                    {{firstDiagramFiltered && firstDiagramData ? (firstDiagramData.text.indexOf('为') >= 0 ? firstDiagramData.text.charAt(0) : firstDiagramData.text.slice(2)) : '主卦'}}
                    <span v-if="diagramSearchList.length == 0" class="title-icon">
                        <i class="iconfont icon-down"></i>
                    </span>
                </div>
                <div class="title2" @click="clickGuaFilter('second')">
                    {{secondDiagramFiltered && secondDiagramData ? (secondDiagramData.text.indexOf('为') >= 0 ? secondDiagramData.text.charAt(0) : secondDiagramData.text.slice(2)) : '变卦'}}
                    <span v-if="diagramSearchList.length == 0" class="title-icon">
                        <i class="iconfont icon-down"></i>
                    </span>
                </div>
            </div>
        </div>
        
        <div v-if="(diagramSearchList && diagramSearchList.length == 0 && !firstDiagramFiltered && !secondDiagramFiltered && curOrderIndex != 0) || (curOrderIndex == 0 && diagramAllRecordOrder == 0)" class="diagram-record-list">
            <div v-if="gotData" class="layout-rl-note">正在加载数据...</div>
            <div v-else-if="diagramRecordList.length == 0" class="diagram-record-no-data">
                <no-data v-bind:noteText="'记录空空如也~'"></no-data>
            </div>
            <div v-else class="layout-rl-content">
                <virtual-list id="DiagramList" class="layout-record-list-list scroll-touch"
                    :data-key="'id'"
                    :data-sources="diagramRecordList"
                    :data-component="itemComponent"
                    :estimate-size="5"
                    :item-class="'list-item-fixed'" />
            </div>
        </div>
        <div v-else-if="diagramSearchList && diagramSearchList.length != 0" class="diagram-record-list overflow-y-scroll">
            <diagram-record-item v-for="dData in diagramSearchList" :key="dData.id" :source="dData"></diagram-record-item>
        </div>
        <div v-else-if="firstDiagramFiltered || secondDiagramFiltered" class="diagram-record-list overflow-y-scroll">
            <div v-if="diagramFilterList.length == 0">
                <no-data v-bind:noteText="'搜索不到您要的结果~'"></no-data>
            </div>
            <div v-else>
                <diagram-record-item v-for="dData in diagramFilterList" :key="dData.id" :source="dData"></diagram-record-item>
            </div>
        </div>
        <div v-else-if="curOrderIndex == 0" class="diagram-record-list overflow-y-scroll">
            <div v-if="diagramAllRecordList.length == 0">
                <no-data v-bind:noteText="'搜索不到您要的结果~'"></no-data>
            </div>
            <div v-else>
                <diagram-record-item v-for="dData in diagramAllRecordList" :key="dData.id" :source="dData"></diagram-record-item>
            </div>
        </div>

        <!-- 子路由 -->
        <router-view></router-view>
        <!-- 全部记录筛选弹框 -->
        <van-popup class="diagram-all-record-popup" v-bind:value="showAllPanel" position="left" :overlay="false">
            <diagram-record-all-panel-vue></diagram-record-all-panel-vue>
        </van-popup>
        <!-- 删除提示弹框 -->
        <delete-record-item-pop></delete-record-item-pop>
    </div>
</template>

<script>
import * as consts from '../../modules/data/base/consts'
import NoData from '../../components/common/NoData.vue'
import DiagramTopBar from '../../layouts/diagram/DiagramTopBar.vue'
import DiagramRecordAllPanelVue from '../../layouts/diagram/DiagramRecordAllPanel.vue'
import DiagramRecordItem from '../../components/diagram/DiagramRecordItem.vue'
import DeleteRecordItemPop from '../../layouts/popup/DeleteRecordItemPop.vue'

export default {
    name: 'DiagramRecord',
    components: { NoData, DiagramTopBar, DiagramRecordAllPanelVue, DiagramRecordItem, DeleteRecordItemPop },
    computed: {
        diagramRecordList() {
            return this.$store.state.diagram.diagramRecordList;
        },
        diagramSearchList() {
            return this.$store.state.diagram.diagramSearchList;
        },
        diagramFilterList() {
            return this.$store.state.diagram.diagramFilterList;
        },
        firstDiagramData() {
            return this.$store.state.diagram.firstDiagramData;
        },
        firstDiagramFiltered() {
            return this.$store.state.diagram.firstDiagramFiltered;
        },
        secondDiagramData() {
            return this.$store.state.diagram.secondDiagramData;
        },
        secondDiagramFiltered() {
            return this.$store.state.diagram.secondDiagramFiltered;
        },
        curOrderIndex() {
            return this.$store.state.diagram.curOrderIndex;
        },
        diagramTimeOrder() {
            return this.$store.state.diagram.diagramTimeOrder;
        },
        createTimeOrder() {
            return this.$store.state.diagram.createTimeOrder;
        },
        showAllPanel() {
            return this.$store.state.diagram.showAllPanel;
        },
        diagramAllRecordOrder() {
            return this.$store.state.diagram.diagramAllRecordOrder;
        },
        diagramAllRecordList() {
            return this.$store.state.diagram.diagramAllRecordList;
        },
        gettingDiagramRecordList() {
            return this.$store.state.diagram.gettingDiagramRecordList;
        }
    },
    data() {
        return {
            gotData: false,
            itemComponent: DiagramRecordItem,
            recordAllList: consts.CONST_DIAGRAM_RECORD_ALL_LIST
        }
    },
    mounted: function() {
        setTimeout(() => {
            if(this.gettingDiagramRecordList) {
                this.updateListDom();
                return;
            }
            this.$store.dispatch('diagram/initDiagramRecordList', {
                cb: () => {
                    this.updateListDom();
                }
            });
        }, 20);
    },
    methods: {
        updateListDom() {
            let listDom = document.getElementById('DiagramList'),
                topbarDom = document.getElementsByClassName('diagram-record-top-part')[0];
            if(listDom && topbarDom) {
                listDom.style.height = (innerHeight-topbarDom.clientHeight)+'px';
            }
        },
        clickAll() {
            this.$store.state.diagram.curOrderIndex = 0;
            this.$store.state.diagram.showAllPanel = true;
        },
        clickRecent() {
            this.$store.dispatch('diagram/orderDiagramRecordByType', {type: 'recent'});
        },
        clickDiagramTime() {
            this.$store.dispatch('diagram/orderDiagramRecordByType', {type: 'diagramtime'});
        },
        clickCreateTime() {
            this.$store.dispatch('diagram/orderDiagramRecordByType', {type: 'createtime'});
        },
        clickGuaFilter(type) {
            if(this.diagramSearchList.length != 0) { return; }
            this.$store.state.diagram.chooseDiagramType = type;

            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('embedded') != -1) {
                curPath = this.$router.history.current.fullPath;
                curPath = curPath.replace('diagramrecord', 'diagramrecord/choosediagram/'+type)
                this.$router.replace(curPath);
            }else {
                this.$router.replace('/diagramrecord/choosediagram/'+type);
            }
        }
    }
}
</script>
